import React, { FC } from 'react';

import CourseList from 'Jsx/Catalog/components/CourseList/CourseList';
import useCatalogSearchCourses from 'Jsx/Catalog/hooks/useCatalogSearchCourses';

const CourseRecommended: FC = () => {
  const { courses, loading } = useCatalogSearchCourses({ noResults: true });

  return <CourseList skeletonItems={12} courses={courses} loading={loading} />;
};

export default CourseRecommended;
